module.exports = __webpack_public_path__ + "static/media/sf-trial-3-wrong.b18f4e4a.mp3";